import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { publicApi } from "@/lib/api";
import { Lock } from "lucide-react";
import PageHead from "@/components/PageHead";

export default function WatchCapsule() {
  const { token } = useParams();
  const [viewToken, setViewToken] = useState(null);
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    const vt = sessionStorage.getItem(`cv_view_${token}`);
    const m = sessionStorage.getItem(`cv_meta_${token}`);
    setViewToken(vt);
    if (m) setMeta(JSON.parse(m));
  }, [token]);

  if (!viewToken) {
    return (
      <div className="max-w-xl mx-auto px-6 py-24 text-center">
        <PageHead title="Session expired | ChronoVaults" noindex />
        <Lock className="mx-auto w-8 h-8 text-white/40 mb-6" strokeWidth={1.2} />
        <h1 className="font-serif text-4xl text-bone">Session expired</h1>
        <p className="text-white/50 mt-3 text-sm">Please verify again to view this capsule.</p>
        <Link to={`/verify/${token}`} className="text-terracotta hover:underline text-sm mt-6 inline-block">
          Return to verification
        </Link>
      </div>
    );
  }

  const videoUrl = publicApi.videoUrl(token, viewToken);

  return (
    <div className="max-w-5xl mx-auto px-6 md:px-10 py-12">
      <PageHead title="Watch capsule | ChronoVaults" noindex />
      <p className="label-mono text-terracotta">Unsealed</p>
      <h1 className="font-serif text-5xl text-bone mt-3 leading-tight">
        {meta?.title || "Your capsule"}
      </h1>
      {meta?.recipient_name ? (
        <p className="text-white/60 mt-3 text-sm">For {meta.recipient_name}</p>
      ) : null}

      <div className="mt-10 border border-white/10 bg-black overflow-hidden" data-testid="video-frame">
        <video controls autoPlay className="w-full max-h-[70vh] bg-black" src={videoUrl} data-testid="capsule-video" />
      </div>

      {meta?.message ? (
        <div className="mt-8 p-6 border-l-2 border-terracotta bg-vault-800">
          <p className="label-mono mb-3">A note</p>
          <p className="font-serif text-2xl text-bone leading-snug">{meta.message}</p>
        </div>
      ) : null}
    </div>
  );
}
